import React, { useEffect, useState, useContext } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import AsyncSelect from "react-select/async";
import { LanguageContext } from "App";

// import CreateFacilityTypeReq from 'Classes/Models/Requests/Administration/CreateFacilityTypeReq';
import UsersApi from "../../../Classes/API/UsersApi";
import SessionsApi from "../../../Classes/API/Administration/SessionsApi";
import searchSessionsReq from "../../../Classes/Models/Requests/Administration/CreateSessionReq";
import searchUsersReq from "../../../Classes/Models/Requests/Users/SearchUser";
import UserTypes from "../../../Classes/Models/Requests/Users/UserTypes";
import CreateAccountingSessionReq0 from "../../../Classes/Models/Requests/AccountingSessions/CreateAccountingSessionReq";
import Swal from "sweetalert2";

const CreateAccountingSession = ({ setCreatedNewSession }) => {
  const { translations } = useContext(LanguageContext);
  const [SessionsSearch, setSessionsSearch] = useState();
  const [Session, setSession] = useState({});

  const [PatientsSearch, setPatientsSearch] = useState();
  const [Patient, setPatient] = useState({});

  const [TherapistId, setTherapistId] = useState("");
  const [TherapistHourId, setTherapistHourId] = useState("");
  const [IsPaidFor, setIsPaidFor] = useState(false);
  const [AppointmentId, setAppointmentId] = useState("");
  const [AccountingEntryId, setAccountingEntryId] = useState("");
  const [OriginalPrice, setOriginalPrice] = useState("");
  const [FinalPrice, setFinalPrice] = useState("");
  const [Discount, setDiscount] = useState("");

  const [ErrorText, setErrorText] = useState(false);
  const [SuccessText, setSuccessText] = useState("");

  const [SelectedSession, setSelectedSession] = useState([]);
  const [SelectedPatient, setSelectedPatient] = useState([]);

  // const[Optionid, setOptionId] = useState([])

  useEffect(() => {
    GetSessions(true).then((res) => {
      setSelectedSession(res);
    });
  }, [Patient]);
  useEffect(() => {
    GetPatients().then((res) => {
      setSelectedPatient(res);
    });
  }, []);

  useEffect(() => {
    if (Object.keys(Session).length > 0 && Object.keys(Patient).length > 0) {
      GetOriginalPrice();
    }
  }, [Session, Patient]);

  const GetSessions = async (inputValue = "", supressError = false) => {
    if (Object.keys(Patient).length < 1) {
      return [];
    }
    let searchReq = new searchSessionsReq();

    if (Patient.getPatient.contractId) {
      searchReq.contractId = Patient.getPatient.contractId;
    } else {
      searchReq.contractId = undefined;
      searchReq.IsContractSession = false;
    }
    searchReq.Name = inputValue;
    searchReq.SecretName = inputValue;

    console.log(searchReq);

    let res = await SessionsApi.SearchSessions(searchReq);

    if (res.status == "Success") {
      let optionsArr = res.data.list.map((item) => ({
        value: item,
        label: item.name,
      }));
      if (inputValue) {
        optionsArr = optionsArr.filter((item) =>
          item.label.toLowerCase().includes(inputValue.toLowerCase())
        );
      }
      return optionsArr;
    }
    return [];
  };

  const GetPatients = async (inputValue = "") => {
    let searchReq = new searchUsersReq();
    let UserTypes1 = new UserTypes();

    searchReq.name = inputValue;
    // searchReq.number = PatientsSearch;
    // searchReq.email = PatientsSearch;
    searchReq.userType = UserTypes1.Patient;
    let res = await UsersApi.SearchUsers(searchReq);

    if (res.status == "Success") {
      let optionsArr = res.data.list.map((item) => ({
        value: item,
        label: item.name,
      }));
      if (inputValue) {
        optionsArr = optionsArr.filter((item) =>
          item.label.toLowerCase().includes(inputValue.toLowerCase())
        );
      }
      return optionsArr;
    }
    return [];
  };

  const GetOriginalPrice = () => {
    if (Patient.nationalityGroup == "Egyptian") {
      setOriginalPrice(Session.egyptianPrice);
    } else if (Patient.nationalityGroup == "Arab") {
      setOriginalPrice(Session.arabPrice);
    } else if (Patient.nationalityGroup == "Other") {
      setOriginalPrice(Session.otherPrice);
    } else {
      setOriginalPrice("PRICE NOT FOUND");
    }
  };

  const ShowPricing = () => {
    if (Object.keys(Session).length > 0 && Object.keys(Patient).length > 0) {
      return (
        <MDBox mt={4} mb={1}>
          <MDTypography
            variant="button"
            fontWeight="regular"
            color="text"
            className="mx-2 font-weight-bold"
          >
            Patient Nationality Group: {Patient.nationalityGroup}, Original Price: {OriginalPrice}{" "}
            EGP
          </MDTypography>
          <MDInput
            type={"number"}
            onChange={(e) => setDiscount(e.target.value)}
            label={"Discount %"}
          ></MDInput>
        </MDBox>
      );
    }
  };

  const onSubmit = async () => {
    console.log(Patient, Session);
    if (Patient?.getPatient?.id === undefined || Session?.id === undefined) {
      Swal.fire({
        title: "Error",
        text: translations.Pleaseselectapatientandsession,
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    let req = new CreateAccountingSessionReq0();

    req.discount = Discount;
    req.isPaidFor = IsPaidFor;
    req.originalPrice = OriginalPrice;
    req.sessionId = Session?.id;
    req.patientId = Patient?.getPatient?.id;

    let res = await SessionsApi.CreateAccountingSession(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Accounting Session Created Successfully",
        icon: "success",
      });

      setCreatedNewSession(true);
    } else {
      Swal.fire({
        title: "Error",
        text: "Something went wrong",
        icon: "error",
      });
    }
  };

  return (
    <Card mb={3} id="CreateAccountingSession">
      <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDButton
          onClick={() => onSubmit()}
          sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
          color="success"
        >
          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
          &nbsp;{translations.createAccountsessionSingleSession}
        </MDButton>
      </MDBox>
      <form id="CreateAccountingSessionForm">
        <MDBox p={3}>
          <MDBox
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p={2}
            sx={{
              flexDirection: {
                xs: "column", // For small screens (mobile), each element will be in a row
                sm: "row", // For larger screens, elements will be in a row (default)
              },
            }}
          >
            <div className="col-md-4">
              <AsyncSelect
                placeholder={translations.createAccountsessionSingleSessionSelectPatient}
                isClearable={true}
                loadOptions={(inputValue) => GetPatients(inputValue)}
                defaultOptions={SelectedPatient}
                onChange={(e) => setPatient(e?.value || {})}
                value={SelectedPatient.find((option) => option.value === Patient) || null}
                styles={{
                  ...(translations.setlang === "ar"
                    ? {
                        control: (base) => ({
                          ...base,
                          direction: "rtl",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          textAlign: "right",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          textAlign: "right",
                        }),
                      }
                    : {}),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999, // Ensure dropdown appears above other elements
                  }),
                }}
              />
            </div>

            <div className="col-md-4">
              <AsyncSelect
                isClearable={true}
                placeholder={translations.createAccountsessionSingleSessionSelectSession}
                loadOptions={(inputValue) => GetSessions(inputValue)}
                onChange={(e) => setSession(e?.value || {})}
                defaultOptions={SelectedSession}
                // value={TypeId}
                styles={
                  translations.setlang === "ar"
                    ? {
                        control: (base) => ({
                          ...base,
                          direction: "rtl",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          textAlign: "right",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          textAlign: "right",
                        }),
                      }
                    : {}
                }
              />
            </div>

            <div className="col-md-4 mb-4">{ShowPricing()}</div>
            <MDBox mt={4} mb={1}>
              <MDTypography variant="overline" color={"success"}>
                {SuccessText}
              </MDTypography>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDTypography variant="overline" color={"error"}>
                {ErrorText}
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </form>
    </Card>
  );
};

export default CreateAccountingSession;
